import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { TractorService } from "@app/tractor/shared/tractor.service";

@Injectable()
export class TractorsSelectResolver {
  constructor(private tractorService: TractorService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.tractorService.listSelectFormat();
  }
}
